import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./ListViewFaculty.module.css";
// import ReadViewPMem from "./ReadViewPMem";
import PanelMemberschedule from "./PanelMemberschedule";
import PanelMemberSListview from "./PanelMemberSListview";
import TeachingProgress from "./normalFaculity/TeachingProgress";
import FaclityDetailProfile from "./FaclityDetailProfile";

function PanelMemberView() {
  const { userId, staff_id, active_tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { STAFFTYPE, DEP, STATUS, DESIGNATION, SEARCHTERM, FAPON, FROM } =
    location.state || {};
  const [activeTab, setActiveTab] = useState(1);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let staff_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);

    if (user && user.user_id) {
      userid = user.user_id;
      staff_type = user.staff_type ? user.staff_type : STAFFTYPE;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const [staffType, setStaffType] = useState(STAFFTYPE); // store staff_type in state

  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");

    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user?.staff_type) {
        setStaffType(user.staff_type);
      }
    } else {
      console.log("User Id not available in session storage");
    }
  }, []);
  useEffect(() => {
    setActiveTab(Number(active_tab) || 1);
  }, [active_tab]);

  const handleTabClick = (index) => {
    setActiveTab(index);

    navigate(`/Faculties/PanelMember/${userId}/${staff_id}/${index}/${FROM}`, {
      state: {
        filDesign: DESIGNATION,
        fillAon: FAPON,
        filStatus: STATUS,
        filSearch: SEARCHTERM,
        filFrom: FROM
      },


    });
  };

  const stateData = {
    filDep: DEP,
    filStatus: STATUS,
    filSearch: SEARCHTERM,
    filDesign: DESIGNATION,
    fillAon: FAPON,
  };
  const navigateToPreviousScreen = () => {
    navigate(`/Faculties/${FROM}`, {
      state: {
        filSearch: SEARCHTERM,
        fillAon: FAPON,
        filStatus: STATUS,
        filFrom: FROM
      },
    });
  };

  return (
    <div className={`${styles.cm_container} BathHeader`}>
      <div className="row align-items-center mb-3">
        <div className="col-md-12 d-flex justify-content-between flex-wrap">
          <h2 className="TitleHeader mb-0">View Panel Member</h2>
          <Link
            to="javascript:void(0)"
            state={stateData}
            className="secondaryButton "
            variant="secondary"
            onClick={navigateToPreviousScreen}
          >
            Back to Panel Member
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          {/* nav-tabs */}
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 1 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-1"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-1"
                aria-selected={activeTab === 1}
                onClick={() => handleTabClick(1)}
              >
                Schedule
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 2 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-2"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-2"
                aria-selected={activeTab === 2}
                onClick={() => handleTabClick(2)}
              >
                Teaching Progress
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 3 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-3"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-3"
                aria-selected={activeTab === 3}
                onClick={() => handleTabClick(3)}
              >
                Salary
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 4 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-4"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-4"
                aria-selected={activeTab === 4}
                onClick={() => handleTabClick(4)}
              >
                Profile
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab content */}
      {activeTab === 1 && (
        <PanelMemberschedule
          staff_type={staff_type}
          userId={userId}
          staff_id={staff_id}
          activeTab={activeTab}
          FROM={FROM}
        />
      )}
      {activeTab === 2 && (
        <TeachingProgress
          staff_type={staff_type}
          staff_id={staff_id}
          userId={userId}
          activeTab={activeTab}
           FROM={FROM}
        />
      )}
      {activeTab === 3 && (
        <PanelMemberSListview
          staff_type={staff_type}
          userId={userId}
          staff_id={staff_id}
          activeTab={activeTab}
           FROM={FROM}
        />
      )}

      {activeTab === 4 && (
        <FaclityDetailProfile
          staff_type={staff_type}
          staff_id={staff_id}
          userId={userId}
          activeTab={activeTab}
          from="ADMIN"
           FROM={FROM}
        />
      )}
      {/* {activeTab === 4 && (
        <ReadViewPMem
          staff_type={staff_type}
          userId={userId}
          staff_id={staff_id}
          activeTab={activeTab}
        />
      )} */}
    </div>
  );
}

export default PanelMemberView;
